var map = {
	"./Foreground_TMS_Apr.webp": 5384,
	"./TruckAssignedBlack.svg": 3773,
	"./TruckDepartfromdepoBlack.svg": 7107,
	"./WarehouseInBlack.svg": 7171,
	"./WarehouseOutBlack.svg": 8523,
	"./city.png": 2943,
	"./fleet.svg": 837,
	"./loginImage_tmsccSPIL_wLogo.webp": 7768,
	"./logoTMScc_vertical.svg": 7672,
	"./logo_spil.webp": 5254,
	"./logo_tms_forwarder.svg": 8636,
	"./logo_tms_forwarder2.svg": 2495,
	"./logo_tms_forwarder3.svg": 3528,
	"./logo_tms_forwarder4.svg": 3604,
	"./logo_tms_spil.svg": 4499,
	"./logo_white.svg": 8757,
	"./logo_white2.svg": 8954,
	"./logo_white3.svg": 1173,
	"./logo_white4.svg": 6072,
	"./truck.svg": 9240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4140;